import React from 'react'
import { Button, Stack, Text } from '@mantine/core'

import {
  CrFormHandle,
  PER_WITNESS_STEPS,
  witnessStepKey,
} from '@/components/Event/CrForm/CrFormStep'

// "Continue to next witness" for the staged CR form. Gated the same way the non-staged
// flow gates its continue button (all step work complete): enabled only when the active
// witness's per-witness steps are marked done. A step only becomes done when it passes
// validation, so this transitively requires a valid witness without re-running validation
// here. Hidden on the last (or only) witness.
export const ContinueToNextWitnessButton: React.FC<{
  form: CrFormHandle
  activeWitnessIndex: number
  onContinue: (index: number) => void
}> = ({ form, activeWitnessIndex, onContinue }) => {
  const count = form.values.events_feedbacks?.length ?? 0
  const nextIndex = activeWitnessIndex + 1

  if (nextIndex >= count) {
    return null
  }

  const stepsDone = PER_WITNESS_STEPS.every(
    step => form.values.steps?.[witnessStepKey(step, activeWitnessIndex)]?.done,
  )

  return (
    <Stack spacing={4} align="flex-start">
      <Button disabled={!stepsDone} onClick={() => onContinue(nextIndex)}>
        Continue to Witness {nextIndex + 1}
      </Button>
      {!stepsDone && (
        <Text size="xs" color="dimmed">
          Mark this witness&apos;s Opening, Questioning, and Closing steps done
          to continue.
        </Text>
      )}
    </Stack>
  )
}
